// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import styled from "styled-components/macro"

const Button = styled.button`
  display: none;
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background-color: ${({ theme }): string => theme.colors.sweetPink};
  top: -5px;
  right: -5px;
  transition: background-color .3s ease;
    
  &:after,
  &:before {
    content: '';
    width: 5px;
    height: 1px;
    background-color: ${({ theme }): string => theme.colors.white};
    position: absolute;
    top: 6px;
    left: 4px;
  }
  
  &:after {
    transform: rotate(45deg);
  }

  &:before {
    transform: rotate(-45deg);
  }
  
  &:hover {
    background-color: ${({ theme }): string => theme.colors.bittersweet};
  }
`

type Props = {
  onClick: (event: React.MouseEvent<HTMLElement>) => void,
  className?: string,
  disabled?: boolean,
}

const RemoveButton = ({ onClick, className, disabled }: Props): React.ReactElement<Props> => (
  <Button type="button" onClick={onClick} className={className} disabled={disabled ?? false} tabIndex={-1}/>
)

export default styled(RemoveButton)``
